import React, {Component} from "react";
import {CONTROL_PANEL_ROUTE} from "../../../../utils/constants/RoutesConstants";
import SettleBreakLoan from "./SettleBreakLoanView";
import {CommonService} from "../../../../service/commons/CommonService";
import {BreakLoanService} from "../../../../service/controlPanel/BreakLoanService";
import {Growl} from "primereact/growl";
import PropTypes from "prop-types";

export default class SettleBreakLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.breakLoanService = new BreakLoanService();
        this.commonService = new CommonService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.setLoanData = this.setLoanData.bind(this);
        this.getCollateralList = this.getCollateralList.bind(this);
        this.handleServiceResponse = this.handleServiceResponse.bind(this);
        this.settleBrokenLoan = this.settleBrokenLoan.bind(this);
        this.cancelBrokenLoan = this.cancelBrokenLoan.bind(this);
        this.onHideCancelMessageDialog = this.onHideCancelMessageDialog.bind(this);
        this.showCancelMessageDialog = this.showCancelMessageDialog.bind(this);
        this.saveCancelMessage = this.saveCancelMessage.bind(this);

        this.state = {
            isLoading: true,
            loanId: this.props.location.state.folio,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanCollateralList: [],
            loanData: [],
            cancelMessage: '',
            displayCancelMessageDialog: false,
        }
    };

    componentDidMount() {
        this.setLoanData();
        this.getCollateralList();
    }

    setLoanData() {
        let selectedLoan = this.state.selectedLoan;
        let loanData = [
            {
                folio: selectedLoan['idFolioPrest'],
                composeName: selectedLoan['emisora'],
                titles: selectedLoan['cantPrestamo'],
                price: selectedLoan['precioVal'],
            }
        ]
        this.setState({
            loanData: loanData,
        });
    }

    getCollateralList() {
        this.commonService.getGuarantee(this.state.loanId)
            .then(response => {
                this.setState({
                    loanCollateralList: response[0],
                });
                this.loading(false);
            });
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    onHideCancelMessageDialog() {
        this.setState({
            displayCancelMessageDialog: false,
            cancelMessage: '',
        });
    }
    showCancelMessageDialog() {
        this.setState({
            displayCancelMessageDialog: true,
        });
    }

    saveCancelMessage(event) {
        const {value} = event.target;
        this.setState((prevState) => {
            return {
                cancelMessage: value,
            };
        });
    }

    settleBrokenLoan() {
        this.loading(true);
        this.breakLoanService.settleBrokenLoan(this.state.loanId)
            .then(response => {
                this.loading(false);
                this.handleServiceResponse(
                    response, "El incumplimiento se ha liquidado exitosamente.")
            });
    }

    cancelBrokenLoan() {
        if(this.state.cancelMessage !== undefined && this.state.cancelMessage !== "") {
            this.loading(true);
            this.breakLoanService.cancelBrokenLoan(this.state.loanId, this.state.cancelMessage)
                .then(response => {
                    this.loading(false);
                    this.handleServiceResponse(
                        response, "El incumplimiento se ha cancelado exitosamente.")
                });
        } else {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Capturar un motivo válido"});
        }
    }

    handleServiceResponse(response, detailMessage) {
        if (response.error !== "") {
            this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
        } else if (response.message === 'Success'){
            this.handleReturnButton({
                severity: 'success',
                sumary: 'Éxito',
                detail: detailMessage,
            });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <SettleBreakLoan
            messagesGrowl = {messagesGrowl}
            isLoading = {this.state.isLoading}
            loanData = {this.state.loanData}
            loanCollateralList = {this.state.loanCollateralList}
            cancelMessage = {this.state.cancelMessage}
            displayCancelMessageDialog = {this.state.displayCancelMessageDialog}
            handleReturnButton = {this.handleReturnButton}
            showCancelMessageDialog = {this.showCancelMessageDialog}
            onHideCancelMessageDialog = {this.onHideCancelMessageDialog}
            saveCancelMessage = {this.saveCancelMessage}
            settleBrokenLoan = {this.settleBrokenLoan}
            cancelBrokenLoan = {this.cancelBrokenLoan}
        />

    }
};

SettleBreakLoanContainer.propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
};